module.exports = __webpack_public_path__ + "img/crypto_queen.e90eaf78.jpeg";